import classNames from 'classnames';
import { CSSProperties, memo, ReactNode } from 'react';
import styles from './IconMenu.module.scss';

type IconMenuProps = {
  fullWidth?: boolean;
  /** `tabs`: Unternavigation einer Seite – mobil als waagerecht wischbare Pillen-Leiste statt Liste */
  variant?: 'menu' | 'tabs';
  headline?: string;
  hasMarginBottom?: boolean;
  hasMarginTop?: boolean;
  noWrap?: boolean;
  columns?: number;
  children?: ReactNode | undefined;
  className?: string;
};

const IconMenuComponent = ({
  fullWidth = false,
  variant = 'menu',
  headline,
  hasMarginTop,
  hasMarginBottom,
  noWrap,
  columns,
  children,
  className,
}: IconMenuProps) => {
  const classes = classNames(
    styles['icon-menu'],
    {
      [styles['full-width']]: fullWidth,
      [styles['margin-top']]: hasMarginTop,
      [styles['margin-bottom']]: hasMarginBottom,
      [styles.tabs]: variant === 'tabs',
    },
    className,
  );

  const childrenClasses = classNames(styles.children, {
    [styles['no-wrap']]: noWrap,
    [styles.grid]: !!columns,
  });

  return (
    <div className={classes} data-icon-menu-variant={variant}>
      {headline && <div className={styles.headline}>{headline}</div>}
      <div
        className={childrenClasses}
        style={columns ? ({ '--icon-menu-columns': columns } as CSSProperties) : undefined}
      >
        {children}
      </div>
    </div>
  );
};

IconMenuComponent.displayName = 'IconMenu';

export const IconMenu = memo(IconMenuComponent);
